export const isBackKey = (k) =>
  ['Backspace', 'Escape', 'BrowserBack'].includes(k);